import { ChangeDetectionStrategy, Component, input } from "@angular/core";
import { TranslationKey } from "@ankaadia/ankaadia-shared";
import { KpiResultFragment } from "@ankaadia/graphql";
import { TranslateDirective } from "../../../shared/transloco/translate.directive";
import { NewUiKpiCardComponent } from "../kpi-card/new-ui-kpi-card.component";

@Component({
  selector: "new-ui-kpi-carousel-panel",
  templateUrl: "./new-ui-kpi-carousel-panel.component.html",
  styleUrl: "./new-ui-kpi-carousel-panel.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateDirective, NewUiKpiCardComponent],
})
export class NewUiKpiCarouselPanelComponent {
  readonly kpis = input.required<KpiResultFragment[]>();
  readonly titleKey = input.required<TranslationKey>();
  readonly icon = input.required<string>();
}
